import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteShowFolderDocument } from './delete.generated';

export const useDeleteShowFolder = (options: ApiOptions<typeof DeleteShowFolderDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(DeleteShowFolderDocument, {
    ...useNotifications(DeleteShowFolderDocument, {
      failure: t('api.show_folders.delete_error'),
      success: t('api.show_folders.delete_success'),
    }),
    ...options,
  });
};
